<template>
  <table class="table table-condensed table-bordered">
      <thead>
        <tr>
          <th>ID</th>
          <th>Pago</th>
          <th>Saldo</th>
          <th>Fecha de pago</th>
          <th>Nro recibo</th>
          <th>Eliminar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="ind" v-for="(p,ind) in getInscripcion.matricula.pagos">
          <td> {{p.id}} </td>
          <td> {{p.monto}} Bs. </td>
          <td> {{p.saldo}} Bs.</td>
          <td> {{p.fecha_pago}} </td>
          <td> {{p.nro_recibo}} </td>
          <td> <a title="Eliminar este pago." v-show="$store.state.cancelarPagoMatricula" @click="preIliminar(getInscripcion.matricula,p)"> <span class="text-white glyphicon glyphicon-trash">. </span> </a> </td>
        </tr>
      </tbody>
    </table>
</template>

<script>
import {parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'

export default {
  props:{ getInscripcion:{type:Object,required:true},listener:{type:Object,required:true} },
  methods:{
    preIliminar( cuota,pago ){
      var vue = this;
      this.$dialog
      .confirm("<b>Confirmar</b>:<br><br>Eliminar el pago de matricula de "+pago.monto+" Bs.<br>Esta accion es irreversible.")
      .then(function() { 
        vue.eliminar( cuota.id,pago.id );
      }).catch(function(e) { 
        window.console.log(e )
      });
    },

    eliminar( idmatricula,idpago ){
      this.msg = "Eliminando...";
      var sql = gql`mutation{ cancelarPagoMatricula(input:{ idmatricula:${idmatricula},idpago:${idpago} }){ok,pago_matricula{id},errors{message}} }`;
      // window.console.log( sql, "FLAG ",this.listener.flag );

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        if( data.data.cancelarPagoMatricula.ok ){
          this.msg = "Exito."
          this.listener.flag = new Date().getTime();
        }else{
          var errores = JSON.stringify(data.data.cancelarPagoMatricula.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          this.msg = vals;
        }
        // window.console.log(data);
      }).catch((error) => {
        this.$notify( parseJsonError( error,'cancelarPagoMatricula' ) )
      })
    },
  },
}
</script>